import { render, staticRenderFns } from "./TplUpdate.vue?vue&type=template&id=6c55aac2&scoped=true&"
import script from "./TplUpdate.vue?vue&type=script&lang=js&"
export * from "./TplUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TplUpdate.vue?vue&type=style&index=0&id=6c55aac2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55aac2",
  null
  
)

export default component.exports